var React = require('react');
var c = require('./module.scss');
var lock = true;

class Menu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentWillReceiveProps(nextProps) {
        let me = this;
        let data = nextProps.data || [];
        outer:
            for (let i = 0 ; i < data.length; i++) {
                if (!data[i].children) {
                    continue;
                }
                for (let n = 0; n < data[i].children.length; n++) {
                    if (data[i].children[n].resourceId == nextProps.activeId) {
                        this.state.openId = data[i].resourceId;
                        this.setState();
                        break outer;
                    }
                }
            }
    }

    handClick(obj, len, e){
        e.preventDefault();
        if (!obj.children || len == 0) {
            if (obj.resUrl) {
                window.location.href = obj.resUrl;
            }
        }
    }

    handleMouseEnter(obj) {
        lock = false;
        this.state.openId = obj.resourceId;
        this.setState({
            openId: this.state.openId
        });
    }

    handleMouseOut() {
        lock = true;
        this.state.openId = '';
        this.setState();
    }

    render() {
        let _this = this;
        return <div className = 'fp-menuWrap'>
            <ul className='fp-menu'>
                {
                    this.props.data.map(function(o, i) {
                        var css = ['fp-menuItem'];
                        var subCss = ['fp-menuSecItems'];

                        let secList = [];
                        if (o.children) {
                            o.children.map(item => {
                                if (item.resType == '00' || item.resType == '01') {
                                    secList.push(item);
                                }
                            });
                        }

                        // 判断当前一级菜单是否选中，选中则增加高亮样式
                        if (o.resourceId == this.props.activeId) {
                            css.push('cur');
                        }
                        if (this.state.openId == o.resourceId) {
                            css.push('cur');
                            if(!lock) {
                                subCss.push('fp-show');
                            }
                        }
                        var top = i*46
                        var d = _this.props.data.length - i
                        var move = secList.length - d
                        if(move>0)
                            top = top - move*46
                        if(top<0)
                            top = 0
                        var oystyle = secList.length>_this.props.data.length?'auto':'unset'
                        // 渲染二级菜单
                        let secItems = secList.length > 0 ?
                            <div className={subCss.join(' ')} style={{height: '100%', overflowY: oystyle}}>
                                <div style={{
                                    width: '100%',
                                    position:'absolute',
                                    top:top+'px'
                                }}>
                                    {secList.map(function(k, i) {
                                        var cz = ['fp-menuSecItemsContent'];
                                        // 判断当前二级菜单是否选中
                                        if (k.resourceId == this.props.activeId) {
                                            // 给二级菜单增加高亮样式
                                            cz.push('fp-secCur');
                                        }
                                        // 判断是否是最后一个二级菜单，如果是，去除底部边框
                                        if (i == secList.length - 1) {
                                            cz.push(c.last);
                                        }
                                        return <a href={k.resUrl} className={cz.join(' ')}>
                                            <div className='fp-menuSecText'>
                                                {k.title}
                                            </div>
                                        </a>;
                                    }.bind(this))}
                                </div>
                            </div> : '';
                        // 渲染一级菜单，并将生成好的二级菜单插入
                        return <li className={css.join(' ')} style={{
                            width: '110px',
                            position:'unset'
                        }}
                                   onMouseEnter={this.handleMouseEnter.bind(this, o)}
                                   onMouseLeave={this.handleMouseOut.bind(this)}
                        >
                            <a href={o.resUrl}
                               onClick={this.handClick.bind(this, o, secList.length)}
                               className={'fp-menuContent' + (secList.length > 0 ? ' fp-menu-folder' : '')}>
                                <i className={'fp-menuIcon ' + 'fp-menuIcon-' + (o.resIcon || 'default')}></i>
                                <span className='fp-menuText'>
                                    {o.title}
                                </span>
                            </a>
                            {secItems}
                        </li>;
                    }.bind(this))
                }
            </ul>
        </div>;
    }
}

module.exports = Menu;




// WEBPACK FOOTER //
// ./component/frame/menu.js